import { BaseService } from '../types/index.js';
import { stringify } from 'query-string';
export class Connect extends BaseService {
    getConnectToken(token) {
        return this._request.send({
            method: 'POST',
            url: '/connect/token',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: stringify(token),
        });
    }
}
